
<div mat-dialog-title class="name">
  Seleccione los campos a exportar
</div>

<div mat-dialog-content class="content">
  <mat-form-field>
    <mat-select [(ngModel)]="selectedColumns" placeholder="Campos a exportar" matChipInputFor="" multiple>
      <mat-select-trigger>
        <mat-chip-set>
          @for (columnKey of selectedColumns(); track columnKey) {
            <mat-chip-row (removed)="removeColumn(columnKey)">
              {{ columns()[columnKey] }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
          }
        </mat-chip-set>
      </mat-select-trigger>
  
      @for (column of columns() | keyvalue ; track column.key){
        <mat-option [value]="column.key">
          {{ column.value }}
        </mat-option>
      }
  
    </mat-select>
      
  </mat-form-field>
</div>

<div mat-dialog-actions class="footer">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button cdkFocusInitial (click)="export()" [disabled]="!selectedColumns().length">Exportar</button>
</div>
